import { faUser, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Fade from 'react-reveal/Fade';
import { faIdCard } from '@fortawesome/free-regular-svg-icons';
import Flip from 'react-reveal/Flip';
import Skills from '../Skills/Skills';


const AboutMe = () => {
    return (

        <div className="container mb-5 text-white">
            <div className="pb-5 pt-3">
                <h3>
                    <Flip top cascade>
                        <span className="pb-2 custom-red-color my-border-bottom">
                            <FontAwesomeIcon icon={faUser} /> About Me
                        </span>
                    </Flip>
                </h3>
            </div>

            <div className="container about-container">



                <Fade bottom >
                    <section>
                        <div className="row">
                            <div className="col-md-4">
                                <p className="fw-bold">
                                    <FontAwesomeIcon icon={faIdCard} /> About Me
                                </p>
                            </div>
                            <div className="col-md-8 ">
                                <p>Hello, I am Junaidul Kader Tanzim, A Front-End Web Developer who uses React.js with a decent knowledge of the backend technology like Node.js, Express.js, MongoDB, REST-API, JSON, Firebase, Debugging and more attiring to build some chaotic websites.</p>


                            </div>
                        </div>
                    </section>
                </Fade>

                <hr />

                <Fade bottom>
                    <section>
                        <div className="row">
                            <div className="col-md-4">
                                <p className="fw-bold">
                                    <FontAwesomeIcon icon={faUserGraduate} /> Education

                                </p>
                            </div>

                            <div className="col-md-8">
                                <div>
                                    <p className="fw-bold my-0">National University</p>
                                    <br />
                                    <p className="fw-bold my-0">Sonar Bangla College, Comilla</p>
                                    <p>BBA(Hon's),Accounting</p>
                                    <ul>
                                        <li>From 2019- Present</li>
                                    </ul>
                                </div>


                            </div>
                        </div>
                    </section>
                </Fade>

                <hr />

                <Fade>
                    <Skills></Skills>
                </Fade>


            </div>




        </div >
    );
};

export default AboutMe;